require("../../../static/js/jquery/jquery.cookie.js");
require("../../../static/js/main.js");
require("../../../static/js/voice-block.js");
